<template>
  <v-dialog open-delay="10000" transition="dialog-bottom-transition" fullscreen>
    <template v-slot:activator="{ on, attrs }">
      <v-img
        :src="require('@/assets/imgs/' + parentFolder + '/' + imageName)"
        :lazy-src="require('@/assets/imgs/' + parentFolder + '/' + imageName)"
        :alt="alt"
        v-bind="attrs"
        v-on="on"
      >
      </v-img>
    </template>
    <template v-slot:default="dialog">
      <v-card color="rgba(0, 0, 0, 0.7)" flat>
        <v-card-title class="mb-6"
          ><v-spacer></v-spacer>
          <v-icon
            class="white--text d-flex align-self-end"
            large
            @click="dialog.value = false"
            >mdi-close
          </v-icon></v-card-title
        >

        <v-img
          :src="require('@/assets/imgs/' + parentFolder + '/' + imageName)"
          :lazy-src="require('@/assets/imgs/' + parentFolder + '/' + imageName)"
          :alt="alt"
          max-height="550"
          contain
        >
        </v-img>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
export default {
  props: {
    imageName: {
      type: String,
    },
    alt: {
      type: String,
    },
    parentFolder: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>